import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import useGroupLockActions from '../../../hooks/useGroupLockActions';
import { useStore } from '../../../hooks';
import SidebarPanelButton from '../SidebarPanelButton';
import buildGroupLockContextualButtons from './buildGroupLockContextualButtons';

const GroupLockControls = ({ showSectionTitle = true, className = '' }) => {
  const { t } = useStore();
  const api = useGroupLockActions();

  const handleKeyDown = useCallback((event, onClick) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  }, []);

  if (!api.hasSelection) {
    return null;
  }

  const buttons = buildGroupLockContextualButtons(api);

  if (buttons.length === 0) {
    return null;
  }

  return (
    <>
      {showSectionTitle && (
        <div className="respark_multi-selection-section-title respark_group-lock-section-title">
          {t('groupLockTitle')}
        </div>
      )}
      <div
        className={`respark_inspector-option-row respark_group-lock-actions-row${className ? ` ${className}` : ''}`}
        role="group"
        aria-label={t('groupLockTitle')}
      >
        {buttons.map(({ id, titleKey, labelKey, Icon, onClick }) => {
          const title = t(titleKey);

          return (
            <div
              key={id}
              className="respark_inspector-option-row-cell"
            >
              <SidebarPanelButton
                className={`respark_group-lock-btn respark_group-lock-btn--${id}`}
                Icon={Icon}
                label={t(labelKey)}
                title={title}
                onClick={onClick}
                onKeyDown={(event) => handleKeyDown(event, onClick)}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

GroupLockControls.propTypes = {
  showSectionTitle: PropTypes.bool,
  className: PropTypes.string,
};

export default GroupLockControls;
